/** Selector for the card inputs inside the widget that must stay left-to-right. */
export const LTR_INPUT_SELECTOR = [
    '.wpwl-control',
    'input.wpwl-control',
    '.wpwl-group-cardNumber input',
    '.wpwl-group-cardHolder input',
    '.wpwl-group-expiry input',
    '.wpwl-group-cvv input',
].join(', ');

/**
 * Builds the `window.wpwlOptions` object read by HyperPay's paymentWidgets.js.
 *
 * @param {{ locale?: string }} detail
 * @param {{ onReady: () => void, onChangeBrand: () => void }} hooks
 */
export function buildWpwlOptions(detail, { onReady, onChangeBrand }) {
    return {
        style: 'plain',
        locale: detail?.locale ?? 'ar',
        showOneClickWidget: false,
        onReady,
        onChangeBrand,

        labels: {
            cardNumber: 'Card Number',
            cardHolder: 'Card Holder Name',
            cvv: 'CVV',
            expiryDate: 'Expiry Date',
        },

        applePay: {
            displayName: 'Hawa Store',
            total: { label: 'Hawa Store' },
            supportedNetworks: ['mada', 'masterCard', 'visa'],
            merchantCapabilities: ['supports3DS', 'supportsCredit', 'supportsDebit'],
            checkAvailability: 'applePayCapabilities',
            buttonSource: 'js',
            buttonStyle: 'black',
            buttonType: 'pay',
            merchantIdentifier: 'hawaa.com.sa',
            countryCode: 'SA',
            supportedCountries: ['SA'],
            version: 3,
        },
    };
}
